import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export const ModalBrowserBackButtonEvent = {
  ON_BACK_BUTTON_PRESSED: 'modal-browser-back-button-event:on-back-button-pressed'
};

export class KeyboardEvent extends Enum {
  static ENTER = 'enter';

  static SHIFT = 'shift';

  static ESCAPE = 'escape';

  static DELETE = 'delete';

  static TAB = 'tab';

  static CMD_S_OVERRIDE = 'cmd_s_override';

  static CMD_K = 'cmd_k';

  static CMD_S = 'cmd_s';

  static CMD_ENTER = 'cmd_enter';

  static CMD_ARROW_LEFT = 'cmd_arrow_left';

  static CMD_ARROW_RIGHT = 'cmd_arrow_right';

  /**
   *
   * @param eventName
   * @returns {*}
   */
  static getEventsMetadata(eventName) {
    return KeyCode[eventName.toUpperCase()];
  }
}

export class KeyCode extends Enum {
  static ENTER = { name: 'enter', value: 13, metaKey: false };
  static SHIFT = { name: 'shift', value: 16, metaKey: false };
  static ESCAPE = { name: 'escape', value: 27, metaKey: false };
  static DELETE = { name: 'delete', value: 8, metaKey: false };
  static TAB = { name: 'tab', value: 9, metaKey: false };
  static CMD_S = { name: 'cmd_s', value: 83, metaKey: true, override: true };
  static CMD_S_OVERRIDE = {
    name: 'cmd_s_override',
    value: 83,
    metaKey: true,
    completeOverride: true
  };
  static CMD_K = { name: 'cmd_k', value: 75, metaKey: true };
  static CMD_ENTER = { name: 'cmd_enter', value: 13, metaKey: true };
  static CMD_ARROW_LEFT = { name: 'cmd_arrow_left', value: 37, metaKey: true };
  static CMD_ARROW_RIGHT = { name: 'cmd_arrow_right', value: 39, metaKey: true };
}

export const YesNoValues = [
  {
    key: true,
    get value() {
      return Lang.t('asset.yes');
    }
  },
  {
    key: false,
    get value() {
      return Lang.t('asset.no');
    }
  }
];

export const OnOffValues = [
  {
    key: true,
    get value() {
      return Lang.t('core.on');
    }
  },
  {
    key: false,
    get value() {
      return Lang.t('core.off');
    }
  }
];

export const YesNoDontKnowValues = [
  { key: true, value: 'Yes' },
  { key: false, value: 'No' },
  { key: null, value: "I don't know" }
];

export const CorrectIncorrectValues = [
  { key: true, value: 'Yes, this is correct' },
  { key: false, value: 'No, this is wrong' }
];

export const MeridiemValues = [
  { key: 'AM', value: 'AM' },
  { key: 'PM', value: 'PM' }
];

export const HadNotHaveValues = [
  {
    key: true,
    get value() {
      return Lang.t('core.had');
    }
  },
  {
    key: false,
    get value() {
      return Lang.t('core.did-not-have');
    }
  }
];
